import { Col, Popover, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { getChrgitmLvName } from '../../../../models/commodity'
import { DateTimeFormatSimple } from '../../../../models/datetime'
import { Material } from '../../../../models/material'
import { ThemeData } from '../../../../theme/ThemeContext'
import styles from './columns.module.css'
import { Checks } from '../../../../models/setting'
import { ItemCompletionType } from '../../../completion/completionSlice'

// 新老目录展示方式
export const getProcuctInfo = (item: any, settings: any, type?: ItemCompletionType) => {
  const mttype = item.mttype
  const materialsCategory = item.materialsCategory
  const packSpec = item.packSpec ? item.packSpec : '-'
  const spec = item.spec ? item.spec : '-'
  const doseCategory = item.doseCategory ? item.doseCategory : '-'
  const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
  const model = item.model ? item.model + '/' : ''
  const accountUnit = item.accountUnit ? item.accountUnit : '-'

  // mttype == 1诊疗 type == ItemCompletionType.ZLCL 处置项目 诊疗/材料一起搜索
  if (type && type == ItemCompletionType.Treatment || mttype == 1 && type == ItemCompletionType.ZLCL) {
    // 诊疗只有个单位，直接显示单位
    return accountUnit
  } else {
    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 包装规格 + 剂型 + 生产厂家
        return packSpec + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 包装规格 + 型号 + 生产厂家
        return packSpec + '/' + model + tenantSupplierName
      } else {
        // 包装规格 + 生产厂家
        return packSpec + '/' + tenantSupplierName
      } 
    } else {
      if (materialsCategory == '0') {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 剂型 + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 规格 + 包装规格 + 型号 + 包装单位（账簿单位） + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + model + tenantSupplierName
      } else {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + tenantSupplierName
      }
    }
  }
}

export const RecipeItemColumns = (
  theme: ThemeData,
  settings: any,
  type?: ItemCompletionType,
  ydkdFlag?: any, //药店开单
  isShowJJ?: any //是否显示进价 
): TableColumnType<Material>[] => {

  const columns: TableColumnType<Material>[] =  [
    {
      title: '项目信息',
      key: 'name',
      className: styles.name,
      render: function MaterialName(_, m) {
        const isDrug = m?.drugCategory == '第一类精神药品' || m?.drugCategory == '第二类精神药品(制剂)'
        const isToxic = m?.anaesthesiaTag == 1 || m?.drugCategory == '毒性药品'
        return {
          props: {
            style: {
              borderLeft: isToxic ? `4px solid #FF20CE` : isDrug ? `4px solid #35d733` : '',
            },
          },
          children: (
            <Col style={{ cursor: 'pointer' }}>
              {(isToxic || isDrug) ? (
                <Popover content={isToxic ? (m?.anaesthesiaTag == 1 ? '属于毒麻类药物' : '毒性药品') : m?.drugCategory == '第一类精神药品' ? '第一类精神药品' : m?.drugCategory == '第二类精神药品(制剂)' ? '第二类精神药品(制剂)' : ''} zIndex={999999}
                >
                  <div
                    className={styles.popoverNameText}
                    style={{
                      color: theme.tc1,
                    }}
                  >
                    {m.name}
                  </div>
                </Popover>
              ) : (
                <div
                  className={styles.nameText}
                  style={{
                    color: theme.tc1,
                  }}
                >
                  {m.name}
                </div>
              )}
              <div
                title={getProcuctInfo(m,settings,type)}
                className={styles.productText}
                style={{
                  color: theme.tc2,
                }}
              >
                {getProcuctInfo(m,settings,type)}
              </div>
            </Col>
          ),
        }
      },
    },
    {
      title: '库房',
      dataIndex: 'storehouseName',
      align: 'center',
      render: (_, m) => (m?.storehouseName ? m?.storehouseName : '/'),
    },
    {
      title: '库存',
      key: 'count',
      align: 'center',
      render: (_, m) => (m.count && m.count > 0 ?`${m.count}${m.accountUnit}` : '/'),
    },
    {
      title: '拆零',
      key: 'split',
      align: 'center',
      render: (_, m) =>
        m.splitTag === 1 && (m.splitCount && m.splitCount > 0)
          ? `${m.splitCount}${m.splitUnit}`
          : '/',
    },
    { title: '单价/元', dataIndex: 'retailPrice', align: 'right' },
    // 药店开单的开启开关的 [Checks.SPJJ] 153 == 1 才展示进价
    {
      title: '进价/元',
      dataIndex: 'catalogStockPrice',
      key: 'catalogStockPrice',
      align: 'right',
      render: (_, m: any) => ( m.catalogStockPrice > 0 ? m.catalogStockPrice : ''),
    },
    {
      title: '等级',
      dataIndex: 'chrgitmLv',
      align: 'center',
      render: (_, m: any) => (m.chrgitmLv ? getChrgitmLvName(m.chrgitmLv) : ''),
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
      dataIndex: 'remark',
      // render: (_, m) => (m.priceLimit > 0 ? `${m.remark} 医保限价：${m.priceLimit}` : `${m.remark}`),
      render: function Remark(_, m): ReactElement {
        return (
          <div
            title={
              `${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')
            }
            className={styles.remarkStyle}
          >
            {`${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')}
          </div>
        )
      },
    },
  ]
  return ydkdFlag && isShowJJ == 1 ? columns : columns.filter((c) => c.key != 'catalogStockPrice')
}

// 按批次
export const RecipeItemColumnsWithBatchNo = (
  theme: ThemeData,
  scene?: string,
  settings?: any,
  type?: ItemCompletionType,
  ydkdFlag?: boolean,
  isShowJJ?: number
): TableColumnType<Material>[] => {

  const columns: TableColumnType<Material>[] = [
    {
      title: '项目信息',
      key: 'name',
      className: styles.name,
      render: function MaterialName(_, m) {
        const isDrug = m?.drugCategory == '第一类精神药品' || m?.drugCategory == '第二类精神药品(制剂)'
        const isToxic = m?.anaesthesiaTag == 1 || m?.drugCategory == '毒性药品'
        return {
          props: {
            style: {
              borderLeft: isToxic ? `4px solid #FF20CE` : isDrug ? `4px solid #35d733` : '',
            },
          },
          children: (
            <Col style={{ cursor: 'pointer' }}>
              {(isToxic || isDrug) ? (
                <Popover content={isToxic ? (m?.anaesthesiaTag == 1 ? '属于毒麻类药物' : '毒性药品') : m?.drugCategory == '第一类精神药品' ? '第一类精神药品' : m?.drugCategory == '第二类精神药品(制剂)' ? '第二类精神药品(制剂)' : ''} zIndex={999999}
                >
                  <div
                    className={styles.popoverNameText}
                    style={{
                      color: theme.tc1,
                    }}
                  >
                    {m.name}
                  </div>
                </Popover>
              ) : (
                <div
                  className={styles.nameText}
                  style={{
                    color: theme.tc1,
                  }}
                >
                  {m.name}
                </div>
              )}
              <div
                title={getProcuctInfo(m,settings,type)}
                className={styles.productText}
                style={{
                  color: theme.tc2,
                }}
              >
                {getProcuctInfo(m,settings,type)}
              </div>
            </Col>
          ),
        }
      },
    },
    {
      title: '批次/有效期至',
      key: 'batch',
      render: function Batch(_, m): ReactElement {
        const deadline = moment(m.deadline)
        const duration = moment.duration(deadline.diff(moment()))
        const warning = deadline.isValid() && duration.asDays() <= 90
        const days = duration.asDays()
        return (
          <Col>
            <div
              style={{
                color: theme.tc1,
                fontSize: '1rem',
                whiteSpace: 'nowrap',
              }}
            >
              批次号：{m.batchNo || '-'}
            </div>
            <div
              style={{
                color: warning ? theme.e : days <= 180 ? '#027AFF' : theme.tc1,
                fontWeight: warning || days <= 180 ? 'bold' : 'normal',
                fontSize: '1rem',
              }}
            >
              {warning
                ? `有效期: ${Math.floor(duration.asDays())}天`
                : `有效期至：${deadline.isValid()
                  ? deadline.format(DateTimeFormatSimple)
                  : '--'
                }`}
            </div>
          </Col>
        )
      },
    },
    {
      title: '库房',
      dataIndex: 'storehouseName',
      align: 'center',
      render: (_, m) => (m?.storehouseName ? m?.storehouseName : '/'),
    },
    {
      title: '库存',
      key: 'count',
      align: 'center',
      render: (_, m) => (m.count && m.count > 0 ?`${m.count}${m.accountUnit}` : '/'),
    },
    {
      title: '拆零',
      key: 'split',
      align: 'center',
      render: (_, m) =>
        m.splitTag === 1 && (m.splitCount && m.splitCount > 0)
          ? `${m.splitCount}${m.splitUnit}`
          : '/',
    },
    // 购入退库不展示单价/元
    {
      title: '单价/元',
      dataIndex: 'retailPrice',
      align: 'center',
      key: 'retailPrice',
    },
    // 购入退库显示进价，药店开单开启了开关展示进价/元
    {
      title: ydkdFlag ? '进价/元' : '进价',
      dataIndex: 'unitPrice',
      align: 'center',
      key: 'unitPrice',
    },
    {
      title: '入库时间',
      dataIndex: 'inboundDate',
      align: 'center',
      key: 'inboundDate',
      render: (_, m:any) => (m.inboundDate ? moment(m.inboundDate).format(DateTimeFormatSimple) : '/'),
    },
    {
      title: '等级',
      dataIndex: 'chrgitmLv',
      align: 'center',
      render: (_, m: any) => (m.chrgitmLv ? getChrgitmLvName(m.chrgitmLv) : ''),
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
      dataIndex: 'remark',
      render: function Remark(_, m): ReactElement {
        return (
          <div
            title={
              `${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')
            }
            className={styles.remarkStyle}
          >
            {`${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')}
          </div>
        )
      },
    },
  ]

  //药店开单开启了开关才展示进价/元 ,购入退库显示进价，不展示单价/元，其余页面不展示进价/元
  return ydkdFlag && isShowJJ == 1 ? columns : scene === 'InputToReturn'
      ? columns.filter((c) => c.key !== 'retailPrice')
      : columns.filter((c) => c.key !== 'unitPrice')
}

export const RecipeItemColumnsSimple = (
  theme: ThemeData,
  settings: any,
  type?: ItemCompletionType,
  ydkdFlag?: any,
  isShowJJ?: any, //是否显示进价 
): TableColumnType<Material>[] => {
   const columns: TableColumnType<Material>[] = [
    {
      title: '项目信息',
      key: 'name',
      className: styles.name,
      render: function MaterialName(_, m) {
        const isDrug = m?.drugCategory == '第一类精神药品' || m?.drugCategory == '第二类精神药品(制剂)'
        const isToxic = m?.anaesthesiaTag == 1 || m?.drugCategory == '毒性药品'
        return {
          props: {
            style: {
              borderLeft: isToxic ? `4px solid #FF20CE` : isDrug ? `4px solid #35d733` : '',
            },
          },
          children: (
            <Col style={{ cursor: 'pointer' }}>
              {(isToxic || isDrug) ? (
                <Popover content={isToxic ? (m?.anaesthesiaTag == 1 ? '属于毒麻类药物' : '毒性药品') : m?.drugCategory == '第一类精神药品' ? '第一类精神药品' : m?.drugCategory == '第二类精神药品(制剂)' ? '第二类精神药品(制剂)' : ''} zIndex={999999}
                >
                  <div
                    className={styles.popoverNameText}
                    style={{color: theme.tc1}}
                  >
                    {m.name}
                  </div>
                </Popover>
              ) : (
                <div
                  className={styles.nameText}
                  style={{color: theme.tc1}}
                >
                  {m.name}
                </div>
              )}
              <div
                title={getProcuctInfo(m,settings,type)}
                className={styles.productText}
                style={{ color: theme.tc2}}
              >
                {getProcuctInfo(m,settings,type)}
              </div>
            </Col>
          ),
        }
      },
    },
    // 购入入库才展示产地
    {
      title: '产地',
      dataIndex: 'origin',
      key: 'origin',
      align: 'center',
      render: function Origin(_, m): ReactElement {
        return (
          <div
            className={styles.originStyle}
          >
            {m.origin ? m.origin : '-'}
          </div>
        )
      },
    },
    {
      title: '单价/元',
      dataIndex: 'retailPrice',
      align: 'right',
    },
    // 药店开单的开启开关的 [Checks.SPJJ] 153 == 1 才展示进价
    {
      title: '进价/元',
      dataIndex: 'costPrice',
      key: 'costPrice',
      align: 'right',
      render: (_, m: any) => (type == ItemCompletionType.Treatment ? m.costPrice > 0 ? m.costPrice : '' :  m.stockPrice > 0 ? m.stockPrice : ''   ),
    },
    {
      title: '等级',
      dataIndex: 'chrgitmLv',
      align: 'center',
      render: (_, m: any) => (m.chrgitmLv ? getChrgitmLvName(m.chrgitmLv) : ''),
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
      dataIndex: 'remark',
      render: function Remark(_, m): ReactElement {
        return (
          <div
            title={
              `${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')
            }
            className={styles.remarkStyle}
          >
            {`${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')}
          </div>
        )
      },
    },
  ]
  // 药店开单 并且开关开启了展示进价 才展示 其余页面都不展示
  return ydkdFlag && isShowJJ == 1 ? columns : columns.filter((c) => c.key != 'costPrice')
}

// 商品管理
export const RecipeItemColumnsSimpleCommodity = (
  theme: ThemeData,
  settings: any
): TableColumnType<Material>[] => {

  // 新老目录展示方式
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const spec = item.spec ? item.spec : '-'
    const packSpec = item.packSpec ? item.packSpec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? item.model + '/' : ''
    const accountUnit = item.accountUnit ? item.accountUnit : '-'

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 包装规格  + 剂型 + 生产厂家
        return packSpec + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 包装规格 + 型号  + 生产厂家
        return packSpec + '/' + model + tenantSupplierName
      } else {
        // 包装规格 + 生产厂家
        return packSpec + '/' + tenantSupplierName
      }
    } else {
      if (materialsCategory == '0') {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 剂型 + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 规格 + 包装规格 + 型号 + 包装单位（账簿单位） + 生产厂家
        return spec + '/' + packSpec + '/' + model + accountUnit + '/' + tenantSupplierName
      } else {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + tenantSupplierName
      }
    }
  }

  return [
    {
      title: '项目信息',
      key: 'name',
      className: styles.name,
      render: function MaterialName(_, m) {
        const isDrug = m?.drugCategory == '第一类精神药品' || m?.drugCategory == '第二类精神药品(制剂)'
        const isToxic = m?.anaesthesiaTag == 1 || m?.drugCategory == '毒性药品'
        return {
          props: {
            style: {
              borderLeft: isToxic ? `4px solid #FF20CE` : isDrug ? `4px solid #35d733` : '',
            },
          },
          children: (
            <Col style={{ cursor: 'pointer' }}>
              {(isToxic || isDrug) ? (
                <Popover content={isToxic ? (m?.anaesthesiaTag == 1 ? '属于毒麻类药物' : '毒性药品') : m?.drugCategory == '第一类精神药品' ? '第一类精神药品' : m?.drugCategory == '第二类精神药品(制剂)' ? '第二类精神药品(制剂)' : ''} zIndex={999999}
                >
                  <div
                    className={styles.popoverNameText}
                    style={{
                      color: theme.tc1,
                    }}
                  >
                    {m.name}{m.genericName != m.name ? `(`+m.genericName+`)`:''}
                  </div>
                </Popover>
              ) : (
                <div
                   className={styles.nameText}
                    style={{
                      color: theme.tc1,
                    }}
                >
                  {m.name}{m.genericName != m.name ? `(`+m.genericName+`)`:''}
                </div>
              )}
              <div
                title={getProcuctInfo(m)}
                className={styles.productText}
                style={{
                  color: theme.tc2,
                }}
              >
                {getProcuctInfo(m)}
              </div>
            </Col>
          ),
        }
      },
    },
    {
      title: '产地',
      dataIndex: 'origin',
      key: 'origin',
      align: 'center',
      render: function Origin(_, m): ReactElement {
        return (
          <div
            className={styles.originStyle}
          >
            {m.origin ? m.origin : '-'}
          </div>
        )
      },
    },
    {
      title: '等级',
      dataIndex: 'chrgitmLv',
      align: 'center',
      render: (_, m: any) => (m.chrgitmLv ? getChrgitmLvName(m.chrgitmLv) : ''),
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
      dataIndex: 'remark',
      render: function Remark(_, m): ReactElement {
        return (
          <div
            title={
              `${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')
            }
            className={styles.remarkStyle}
          >
            {`${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')}
          </div>
        )
      },
    },
  ]
}

// 套餐新增 -》商品名搜搜
export const RecipeItemColumnsSimpleBatchNo = (
  theme: ThemeData,
  settings: any
): TableColumnType<Material>[] => {

  return [
    {
      title: '项目信息',
      key: 'name',
      className: styles.name,
      render: function MaterialName(_, m): ReactElement {
        return (
          <Popover
            overlayClassName={styles.popverContent}
            zIndex={999999}
            placement='top'
            content={
              <>
                <div
                  className={styles.popoverNameText}
                  style={{
                    color: theme.tc1,
                  }}
                >
                  {m.name}
                </div>
                <div
                 className={styles.popoveProductText}
                  style={{
                    color: theme.tc2,
                  }}
                >
                  {getProcuctInfo(m,settings)}
                </div>
              </>
            }
          >
            <Col style={{ cursor: 'pointer' }}>
              <div
                className={styles.nameText}
                style={{
                  color: theme.tc1,
                }}
              >
                {m.name}
              </div>
              <div
                className={styles.productInfo}
                style={{
                  color: theme.tc2,
                }}
              >
                {getProcuctInfo(m,settings)}
              </div>
            </Col>
          </Popover>
        )
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
    },
    {
      title: '单价/元',
      dataIndex: 'retailPrice',
      align: 'right',
    },
    {
      title: '等级',
      dataIndex: 'chrgitmLv',
      align: 'center',
      render: (_, m: any) => (m.chrgitmLv ? getChrgitmLvName(m.chrgitmLv) : ''),
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center',
      dataIndex: 'remark',
      render: function Remark(_, m): ReactElement {
        return (
          <div
            title={
              `${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')
            }
            className={styles.remarkStyle}
          >
            {`${m.remark}` +
              (m.priceLimit > 0 && m.priceLimit < 99999
                ? ` 医保限价：${m.priceLimit}`
                : '')}
          </div>
        )
      },
    },
  ]
}

export const RecipeItemMoreBatchNumColumns = (
  theme: ThemeData,
  settings : any
): TableColumnType<Material>[] => {

  return [
    {
      title: '名称',
      key: 'name',
      className: styles.name,
      render: function MaterialName(_, m): ReactElement {
        return (
          <Popover
            overlayClassName={styles.popverContent}
            zIndex={999999}
            placement='top'
            content={
              <>
                <div
                  className={styles.popoverNameText}
                  style={{
                    color: theme.tc1,
                  }}
                >
                  {m.name}
                </div>
                <div
                   className={styles.popoveProductText}
                  style={{
                    color: theme.tc2,
                  }}
                >
                  {getProcuctInfo(m,settings)}
                </div>
              </>
            }
          >
            <Col style={{ cursor: 'pointer' }}>
              <div
                className={styles.nameText}
                style={{
                  color: theme.tc1,
                }}
              >
                {m.name}
              </div>
              <div
               className={styles.productText}
                style={{
                  color: theme.tc2,
                }}
              >
                {getProcuctInfo(m,settings)}
              </div>
            </Col>
          </Popover>
        )
      },
    },
  ]
}

// 套餐
export const RecipeItemColumnTC = (
  theme: ThemeData
): TableColumnType<Material>[] => {
  return [
    {
      title: '套餐名称',
      key: 'name',
      className: styles.name,
      render: function MaterialName(_, m): ReactElement {
        return (
          <Popover
            overlayClassName={styles.popverContent}
            zIndex={999999}
            placement='top'
            content={
              <>
                <div
                  className={styles.nameText}
                  style={{
                    color: theme.tc1,
                  }}
                >
                  {m.name}
                </div>
              </>
            }
          >
            <Col style={{ cursor: 'pointer' }}>
              <div
                className={styles.nameText}
                style={{
                  color: theme.tc1,
                }}
              >
                {m.name}
              </div>
            </Col>
          </Popover>
        )
      },
    },
    {
      title: '套餐条数',
      key: 'name',
      className: styles.name,
      render: (_, m: any) => {
        return `共${m.count}条`
      },
    },
  ]
}

